import React from 'react';
import { Outlet } from 'react-router-dom';

function ShippingScene() {
  return <Outlet />;
}

export default ShippingScene;
